import { create } from 'zustand'

/** Why the app can't talk to the server right now. `null` means everything is fine. */
export type ConnectionProblem = 'offline' | 'server' | null

interface ConnectionState {
  problem: ConnectionProblem
  setProblem: (problem: ConnectionProblem) => void
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  problem: typeof navigator !== 'undefined' && !navigator.onLine ? 'offline' : null,
  setProblem: (problem) => set((s) => (s.problem === problem ? s : { problem })),
}))

// The browser tells us about a lost or restored connection before any request fails.
if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => useConnectionStore.getState().setProblem('offline'))
  window.addEventListener('online', () => useConnectionStore.getState().setProblem(null))
}
